// extracted by mini-css-extract-plugin
export default {"container":"Ring_container__UPFpS"};